export function isoWeek(dateStr: string): string {
  const dt = new Date(dateStr)
  dt.setHours(0, 0, 0, 0)
  dt.setDate(dt.getDate() + 3 - ((dt.getDay() + 6) % 7))
  const w1 = new Date(dt.getFullYear(), 0, 4)
  const wk = 1 + Math.round(((dt.getTime() - w1.getTime()) / 864e5 - 3 + ((w1.getDay() + 6) % 7)) / 7)
  return `${dt.getFullYear()}-W${String(wk).padStart(2, '0')}`
}

export function isoMonth(dateStr: string): string {
  return dateStr.slice(0, 7)
}

export function isoQuarter(dateStr: string): string {
  const m = parseInt(dateStr.slice(5, 7))
  return dateStr.slice(0, 4) + '-Q' + Math.ceil(m / 3)
}

export function isoYear(dateStr: string): string {
  return dateStr.slice(0, 4)
}

export function getWeekKey(offset = 0): string {
  const d = new Date()
  d.setDate(d.getDate() + offset * 7)
  return isoWeek(d.toISOString().slice(0, 10))
}

export function formatRelativeTime(dateStr: string): string {
  const d = new Date(dateStr)
  const mins = Math.round((Date.now() - d.getTime()) / 60000)
  if (mins < 60) return `${mins}m ago`
  if (mins < 1440) return `${Math.round(mins / 60)}h ago`
  return `${Math.round(mins / 1440)}d ago`
}

// Sync runs daily at 07:00 Prague time, so a bit over 24h is still normal —
// "warning" gives one missed run's worth of slack before flagging "bad".
export function syncFreshness(updatedAt: string | null): 'good' | 'warning' | 'bad' | 'unknown' {
  if (!updatedAt) return 'unknown'
  const hours = (Date.now() - new Date(updatedAt).getTime()) / 3600000
  if (hours < 30) return 'good'
  if (hours < 48) return 'warning'
  return 'bad'
}

// The date range a period-over-period comparison actually covers, so "this period
// vs last period" reads as something concrete instead of a vague relative phrase.
export function periodDateRangeLabel(customDateFrom: string | null, customDateTo: string | null, periodDays: number): string {
  const fmt = (d: Date) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
  if (customDateFrom && customDateTo) {
    return `${fmt(new Date(customDateFrom))} – ${fmt(new Date(customDateTo))}`
  }
  const to = new Date()
  const from = new Date()
  from.setDate(from.getDate() - periodDays)
  return `${fmt(from)} – ${fmt(to)}`
}
